import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'

/**
 *
 * @param amountTendered
 * @returns Function to build LSPay payment options for the LSPay payment type modal
 */
export const useHandleLSPay = (amountTendered: string) => {
  const handleLSPay = useCallback((
    paymentType: ApiRetailerPaymentType,
    intentId?: string, // ONLY used for transaction recovery
    transactionId?: string,
    recoveryAmount?: string | number
  ) => {
    // TODO: Implement LSPay handling
  }, [])
  return {
    handleLSPay,
  }
}
